import { render, staticRenderFns } from "./ScheduleTaskAndEvents.vue?vue&type=template&id=8548b584&"
import script from "./ScheduleTaskAndEvents.vue?vue&type=script&lang=js&"
export * from "./ScheduleTaskAndEvents.vue?vue&type=script&lang=js&"
import style0 from "./ScheduleTaskAndEvents.vue?vue&type=style&index=0&id=8548b584&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports